<template>
    <div class="g2-chart-search">
        <Row>
            <Form :label-width="labelWidth">
                <Col v-for="(el, i) in attrs.children" :key="i" :span="el.span ? el.span : '8'">
                    <FormItem :label="labelWidth > 0 ? el.title : ''">
                        <ly-hoc :attrs="el" v-model="bindForm[el.field]"></ly-hoc>
                        <div class="form-tips" v-if="el.tipsTxt">{{el.tipsTxt}}</div>
                    </FormItem>
                </Col>
            </Form>
        </Row>
        <div class="g2-chart-btn">
            <Button type="primary" icon="ios-search" @click="doSearch">搜索</Button>
        </div>
        <Divider />
    </div>
</template>
<script>
    export default {
        props: {
            attrs: {
                type: Object,
                default: _ => new Object()
            } // 组件的配置
        },
        data () {
            return {
                bindForm: {}, // 组件绑定的字段
            }
        },
        computed: {
            labelWidth () {
                let width = 120
                if (!isNaN(this.attrs.labelWidth)) {
                    width = parseInt(this.attrs.labelWidth)
                }
                return width
            }
        },
        mounted() {
            console.log("bindform", this.bindForm)
            if(Object.keys(this.bindForm).length > 0) {
                this.doSearch()
            }
        },
        methods: {
            doSearch () {
                console.log("search", this.bindForm)
                this.$emit('search', this.bindForm)
            }
        }
    }
</script>
<style>
    .g2-chart-search {
        position: relative;
        min-height: 35px;
        padding-top: 20px;
    }
    .g2-chart-search > Row {
        padding-right: 120px;
    }
    .g2-chart-btn {
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -30px;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/g2-chart/src/search.vue